import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../../helpers/fackBackend_Helper";

function* purchaseInventoryResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Inventory/PurchaseInventory", data);
    if (response?.statusCode == 1200) {
      yield put(actions.purchaseInventorySuccess(response?.message));
    } else {
      yield put(actions.purchaseInventoryError(response?.message, response?.data));
    }
  } catch (error) {
    yield put(actions.purchaseInventoryError(error));
  }
}

function* getPurchaseSimListResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Inventory/SimPurchaseList", data);
    if (response?.statusCode == 1200) {
      yield put(actions.getPurchaseSimListSuccess(response?.data));
    } else {
      yield put(actions.getPurchaseSimListError(response?.message));
    }
  } catch (error) {
    yield put(actions.getPurchaseSimListError(error));
  }
}

function* getSimListResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, '/API/V1/Inventory/SimList', data);
    if (response?.statusCode == 1200) {
      yield put(actions.getSimListSuccess(response?.data));
    } else {
      yield put(actions.getSimListError(response?.message));
    }
  } catch (error) {
    yield put(actions.getSimListError(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.PURCHASE_INVENTORY, purchaseInventoryResponse)]);
  yield all([takeEvery(actions.GET_PURCHASE_SIM_LIST, getPurchaseSimListResponse),]);
  yield all([takeEvery(actions.GET_SIM_LIST, getSimListResponse)]);
}
